import service from '@/utils/server';
let model = '/fm/fmUser/'
export const queryList = data => {
    return service({
        url: model+'pageInfo',
        method: 'post',
        data
    })
};

export const saveObject = data => {
    return service({
        url: model+'add',
        method: 'post',
        data
    })
};

export const getAllCustomerList = data => {
  return service({
    url: model+'getAllCustomerList',
    method: 'post',
    data
  })
};


export const updateObject = data => {
    return service({
        url: model+'update',
        method: 'post',
        data
    })
};

//
export const getAllRoleList = data => {
  return service({
    url: model+'getAllRoleList/'+data.clientId,
    method: 'post'
  })
};

//
export const getResetRoleList = data => {
  return service({
    url: model+'resetRole',
    method: 'post',
    data
  })
};

//
export const getResetPwd = data => {
  return service({
    url: model+'resetPwd',
    method: 'post',
    data
  })
};
export const getForceResetPwd = data => {
  return service({
    url: model+'forceResetPwd',
    method: 'post',
    data
  })
};
export const getDeleteUserList = data => {
  return service({
    url: model+'delete/'+data.userId,
    method: 'post'
  })
};
//rdc
export const getAllRdcList = data => {
  return service({
    url: model+'initRolePrivilegeData/'+data.id,
    method: 'post'
  })
};

//角色设置初始化权限数据(全量客户组 + 已选客户组)
export const initRolePrivilegeData = data => {
  return service({
    url: model+'initRolePrivilegeData/'+data.id,
    method: 'post'
  })
};

// 客户组全量查询(角色设置 transfer 用,支持 groupName/soldtoNo/soldtoName 模糊)
export const getAllCustomerGroupList = data => {
  return service({
    url: model+'getAllCustomerGroupList',
    method: 'post',
    data
  })
};

//carrier
export const getAllCarrierList = data => {
  return service({
    url: model+'getAllCarrierList/'+data.clientId,
    method: 'post'
  })
};


//userType
export const listUserType = data => {
  return service({
    url: model+'userType/'+data.clientId,
    method: 'post'
  })
};

//承运商搜索
export const searchCarrierList = data => {
  return service({
    url: model+'getAllCarrierList',
    method: 'post',
    data
  })
};

//rdc搜索
export const searchRdcList = data => {
  return service({
    url: model+'getAllWhList',
    method: 'post',
    data
  })
};




// WEBPACK FOOTER //
// ./src/page/auth/user/api/index.js